// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VZ4j","question":"styles_question__2-oNp","inputVisibleButton":"styles_inputVisibleButton__3Fisf","note":"styles_note__3cyTb"};